import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable()
export class AuthGuardService implements CanActivate {

  constructor(public auth: AuthService, public router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    if (!this.auth.isAuthenticated()) {
      this.router.navigate(['auth']);
      return false;
    }
     const requiredRole = route.data['requiredRole'];
  if (requiredRole && !this.auth.hasRole([requiredRole])) {
    this.router.navigate(['unauthorized']); // Προαιρετικά
    return false;
  }


    return true;
  }
}
